require('../monitor/console');
module.exports = require('./when.browserify.js');

